import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dash2',
  templateUrl: './dash2.component.html',
  styleUrls: ['./dash2.component.css']
})
export class Dash2Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }


  toolTip = function(){
   return  alert('sdasd');
  };




}
